import { OBJECT_ID_ZERO } from '../constants';

export const hasObjectId = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }

  return value !== OBJECT_ID_ZERO;
};

export const fixObjectId = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  return value !== OBJECT_ID_ZERO ? value : undefined;
};
